import { useEffect, useState } from "react";
import { Card, Typography } from "@mui/material";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";
import FormControlLabel from "@mui/material/FormControlLabel";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import { Remove, Add } from "@mui/icons-material";
import { useDebounce } from "../../hooks";
import { useOutletContext } from "react-router-dom";
import { getAllClients } from "../UserManager/Client/Helper";
import { getAllVendors } from "../UserManager/Vendor/Helper";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import Swal from "sweetalert2";
import { createSubscription } from "./Helper";
import { useLocation } from "react-router-dom";
import Checkbox from "@mui/material/Checkbox";



export default function CustomSub() {
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const role = queryParams.get("role");
  const userId = queryParams.get("userId");
  const name = queryParams.get("name");
  const custom = queryParams.get("custom") === "true";
  const vendorFields = ["User Accounts", "Job Broadcasting Credits", "Job Broadcasting + Agentic" ,"Intellica Credits", "Talent Pool", "Gmeet/Teams", "Vendor Exclusive Jobs", "RMS"];
  const clientFields = ["User Accounts", "Job Broadcasting Credits", "Job Broadcasting + Agentic" ,"Intellica Credits", "Talent Pool", "Gmeet/Teams", "VMS", "Vendor Exclusive Jobs"];

  const [selectedUser, setSelectedUser] = useState(null);
  const [users, setUsers] = useState([]);
  const [search, setSearch] = useState("");
  const [loading, setLoading] = useState(false);
  const [userType, setUserType] = useState(role || "client");
  const [sendEmail, setSendEmail] = useState(false);
  const fields = userType === 'vendor' ? vendorFields : clientFields;
  const [fieldValues, setFieldValues] = useState(
    fields.reduce((acc, field) => ({
      ...acc,
      [field]:
        field === "VMS" || field === "RMS"
          ? ""
          : field === "Gmeet/Teams" || field === "Vendor Exclusive Jobs"
            ? field === "Vendor Exclusive Jobs" ? 0 : true
            : 0
    }), {})
  );
  const [fieldModes, setFieldModes] = useState(
    fields.reduce((acc, field) => ({ ...acc, [field]: "custom" }), {})
  );

  const [subTotal, setSubTotal] = useState("");
  const [currency, setCurrency] = useState("INR");
  const [planType, setPlanType] = useState("onetime");
  const [finalAmount, setFinalAmount] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);

  const debouncedSearch = useDebounce(search, 500);
  const context = useOutletContext();

  const handleChange = (field, delta) => {
    if (field === "VMS" || field === "RMS" || field === "Gmeet/Teams" ) return; // Don't change VMS with +/- controls

    setFieldValues((prev) => ({
      ...prev,
      [field]: Math.max(0, (prev[field] || 0) + delta),
    }));
  };

  const handleModeChange = (field, mode) => {
    setFieldModes(prev => ({
      ...prev,
      [field]: mode
    }));
  };

  useEffect(() => {
    const subTotalNum = parseFloat(subTotal) || 0;
    if (currency === "INR") {
      setFinalAmount(subTotalNum + (subTotalNum * 0.18));
      setTaxAmount(subTotalNum * 0.18)
    } else {
      setFinalAmount(subTotalNum + (subTotalNum * 0.05));
      setTaxAmount(subTotalNum * 0.05)
    }
  }, [subTotal, currency]);

  // Set vendor only job based on VMS selection
  useEffect(() => {
    if (userType === "client" && fieldValues["VMS"]) {
      let vendorOnlyJobCount = 0;

      switch (fieldValues["VMS"]) {
        case "basic":
          vendorOnlyJobCount = 10;
          break;
        case "advance":
          vendorOnlyJobCount = 25;
          break;
        case "premium":
          vendorOnlyJobCount = 50;
          break;
        case "premiumPlus":
          vendorOnlyJobCount = 'Unlimited'; // Using a high number to represent unlimited
          break;
        default:
          vendorOnlyJobCount = 0;
      }

      setFieldValues(prev => ({
        ...prev,
        "Vendor Exclusive Jobs": vendorOnlyJobCount
      }));
    }
  }, [fieldValues["VMS"], userType]);

  const handleSubmit = async () => {
    // if (!selectedUser) return;
    const input = Object.entries(fieldValues).reduce((acc, [field, value]) => {
      if (field === "VMS" || field === "RMS") {
        acc[field] = value || null;
      } else if (field === "Gmeet/Teams" ) {
        // Don't include Gmeet/Teams in this object, we'll handle it separately
      } else {
        acc[field] = fieldModes[field] === "unlimited" ? "unlimited" : value;
      }
      return acc;
    }, {})
    const data = {
      amount: Math.round(finalAmount),
      display_amount: subTotal,
      gstAmount: taxAmount,
      interval: planType,
      createdFor: custom ? userId : selectedUser?.id,
      paymentProvider: currency === 'INR' ? 'RAZORPAY' : 'STRIPE',
      role: userType.toUpperCase(),
      sendEmail: sendEmail,
      onetime_payment : planType === "onetime" ? true : false,
      usage: {
        jobPosting: input["Job Broadcasting Credits"],
        users: input["User Accounts"],
        aiInterviewCredits: input["Intellica Credits"],
        talentPoolCredits: input["Talent Pool"],
        premiumJobCredits: fieldValues["Job Broadcasting + Agentic"],
        interviewIntegration: fieldValues["Gmeet/Teams"],
        talentPool: fieldValues["Talent Pool"],
        // vendorJob:  fieldValues["Vendor Marketplace Job"],
        vendorOnlyJobs: fieldValues["Vendor Exclusive Jobs"]
      },
      ...(userType === "client" && {
        planType: input["VMS"] ? input["VMS"].toUpperCase() : null
      }),
      ...(userType === "vendor" && {
        planType: input["RMS"] ? input["RMS"].toUpperCase() : null
      })
    };
    const resp = await createSubscription(data);
    if (resp.data.success) {
      Swal.fire({
        icon: 'success',
        title: 'Custom Subscription Created Successfully',
        confirmButtonText: 'OK',
        timer: 3000,
        timerProgressBar: true,
      });
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Something went wrong!',
        text: 'Please try again later.',
        confirmButtonText: 'OK',
        timer: 3000,
        timerProgressBar: true,
      });
    }
    setSendEmail(false);
    setFieldValues(fields.reduce((acc, field) => ({
      ...acc,
      [field]: field === "VMS" || field === "RMS"
        ? ""
        : (field === "Gmeet/Teams" )
          ? true
          : field === "Vendor Exclusive Jobs"
            ? 0
            : 0
    }), {}));
    setFieldModes(fields.reduce((acc, field) => ({ ...acc, [field]: "custom" }), {}));
    setSelectedUser(null);
    setSearch("");
    setUsers([]);
    setSubTotal("");
    setFinalAmount(0);
  };

  useEffect(() => {
    context(["Custom Subscription"]);
  }, []);

  useEffect(() => {
    const fetchUsers = async () => {
      setLoading(true);
      try {
        if (userType === "client") {
          const response = await getAllClients("", "", debouncedSearch);
          if (response?.data?.clients?.rows) {
            setUsers(response.data.clients.rows);
          }
        } else {
          const response = await getAllVendors("", "", debouncedSearch);
          if (response?.data?.vendors?.rows) {
            setUsers(response.data.vendors.rows);
          }
        }
      } catch (err) {
        console.error(`Error fetching ${userType}s:`, err);
        setUsers([]);
      } finally {
        setLoading(false);
      }
    };

    if (debouncedSearch.length > 0) {
      fetchUsers();
    } else {
      setUsers([]);
    }
  }, [debouncedSearch, userType]);

  useEffect(() => {
    setSelectedUser(null);
    setSearch("");
    setUsers([]);
    setFieldValues(fields.reduce((acc, field) => ({
      ...acc,
      [field]: field === "VMS" || field === "RMS"
        ? ""
        : (field === "Gmeet/Teams" )
          ? true
          : field === "Vendor Exclusive Jobs"
            ? 0
            : 0
    }), {}));
    setFieldModes(fields.reduce((acc, field) => ({ ...acc, [field]: "custom" }), {}));
    setSubTotal("");
    setFinalAmount(0);
  }, [userType]);

  const getUserDisplayName = (user) => {
    if (!user) return "";
    if (typeof user === "string") return user;

    const name = user.firstName + " " + user.lastName || user.name || user.userName || "Unknown User";
    const email = user.email ? ` (${user.email})` : "";
    const company = user.company ? ` - ${user.company}` : "";

    return `${name}${email}${company}`;
  };

  const getName = (val) => {
    return val.firstName + " " + val.lastName
  }

  const renderFieldControl = (field) => {
    if (field === "Gmeet/Teams") {
      return (
        <div className="flex justify-end items-center gap-2 w-2/3">
          <div className="flex items-center">
            <RadioGroup
              row
              value={fieldValues[field] ? "yes" : "no"}
              onChange={(e) => setFieldValues(prev => ({
                ...prev,
                [field]: e.target.value === "yes"
              }))}
              sx={{ flexWrap: 'nowrap' }}
            >
              <FormControlLabel
                value="yes"
                control={
                  <Radio
                    sx={{
                      '&.Mui-checked': {
                        color: '#3b82f6',
                      },
                    }}
                  />
                }
                label="Yes"
              />
              <FormControlLabel
                value="no"
                control={
                  <Radio
                    sx={{
                      '&.Mui-checked': {
                        color: '#3b82f6',
                      },
                    }}
                  />
                }
                label="No"
              />
            </RadioGroup>
          </div>
        </div>
      );
    }
    if (field === "VMS" && userType === "client") {
      return (
        <Select
          value={fieldValues[field]}
          onChange={(e) => setFieldValues(prev => ({ ...prev, [field]: e.target.value }))}
          size="small"
          displayEmpty
          sx={{
            width: '150px',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#3b82f6',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#3b82f6',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#3b82f6',
            },
          }}
        >
          <MenuItem value="" disabled>
            <em>Select VMS</em>
          </MenuItem>
          <MenuItem value="basic">Basic (10 vendor-exclusive job, 10 Timesheets, 10 Invoices ,Add and Mange 10 Vendors)</MenuItem>
          <MenuItem value="advance">Advanced (25 vendor-exclusive job, 25 Timesheets, 25 Invoices ,Add and Mange 25 Vendors)</MenuItem>
          <MenuItem value="premium">Premium (50 vendor-exclusive job, 50 Timesheets, 50 Invoices ,Add and Mange 50 Vendors)</MenuItem>
          <MenuItem value="premiumPlus">Premium+ (unlimited vendor-exclusive job, unlimited Timesheets, unlimited Invoices ,Add and Mange unlimited Vendors)</MenuItem>
        </Select>
      );
    }
    if (field === "RMS" && userType === "vendor") {
      return (
        <Select
          value={fieldValues[field]}
          onChange={(e) => setFieldValues(prev => ({ ...prev, [field]: e.target.value }))}
          size="small"
          displayEmpty
          sx={{
            width: '150px',
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: '#3b82f6',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              borderColor: '#3b82f6',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              borderColor: '#3b82f6',
            },
          }}
        >
          <MenuItem value="" disabled>
            <em>Select RMS</em>
          </MenuItem>
          <MenuItem value="basic">Basic (10 resource managed(one time),10 Job submissions(recurring), AI converted resume - 50(recurring))</MenuItem>
          <MenuItem value="advance">Advanced (25 resource managed, 25 jobs submissions, AI converted resume - 100)</MenuItem>
          <MenuItem value="premium">Premium (50 resource managed job, 50 jobs submissions, AI converted resume - 100)</MenuItem>
          <MenuItem value="premiumPlus">Premium+ (  unlimited resource managed,unlimited jobs submissions, AI converted resume - 200)</MenuItem>
        </Select>
      );
    }

    // Special case for Vendor Only Job when it's unlimited
    if (field === "Vendor Exclusive Jobs" && userType === "client" && fieldValues["VMS"] === "premiumPlus") {
      return (
        <div className="flex justify-end items-center gap-2 w-2/3">
          <div className="flex items-center">
            <span className="px-4 py-1 bg-blue-100 text-blue-800 rounded-lg font-medium">
              Unlimited
            </span>
          </div>
        </div>
      );
    }

    // Default for other fields (without unlimited option)
    return (
      <div className="flex justify-end items-center gap-2 w-2/3">
        <div className="flex items-center">
          <Button
            variant="outlined"
            size="small"
            onClick={() => handleChange(field, -1)}
          >
            <Remove fontSize="small" />
          </Button>
          <input
            type="number"
            value={fieldValues[field] || 0}
            onChange={(e) => {
              const value = Math.max(0, parseInt(e.target.value) || 0);
              setFieldValues(prev => ({
                ...prev,
                [field]: value
              }));
            }}
            min="0"
            style={{
              width: '60px',
              textAlign: 'center',
              fontSize: '14px',
              padding: '4px'
            }}
          />
          <Button
            variant="outlined"
            size="small"
            onClick={() => handleChange(field, 1)}
          >
            <Add fontSize="small" />
          </Button>
        </div>
      </div>
    );
  };

  // Determine if the Vendor Only Job field should be displayed
  const shouldShowField = (field) => {
    if (field === "Vendor Exclusive Jobs" && userType !== "client") {
      return true;
    }
    return true;
  };

  return (
    <div className="flex flex-col items-center min-h-screen bg-gray-100 p-6">
      <Card className="w-[650px] p-6 bg-white shadow-lg rounded-2xl">
        <h2 className="text-2xl font-bold text-gray-800 mb-4 text-center">
          Custom Subscription {selectedUser || custom ? <span className="text-blue-500">For {custom ? name : getName(selectedUser)}</span> : ''}
        </h2>

        <div className="mb-4">
        {!custom ? (
          <div className="flex justify-center mb-4">
            <RadioGroup
              row
              value={userType}
              onChange={(e) => setUserType(e.target.value)}
              name="user-type-group"
            >
              <FormControlLabel
                value="client"
                control={
                  <Radio
                    sx={{
                      '&.Mui-checked': {
                        color: '#3b82f6',
                      },
                    }}
                  />
                }
                label="Client"
              />
              <FormControlLabel
                value="vendor"
                control={
                  <Radio
                    sx={{
                      '&.Mui-checked': {
                        color: '#3b82f6',
                      },
                    }}
                  />
                }
                label="Vendor"
              />
            </RadioGroup>
          </div>
          ) : (
            <div className="flex justify-center mb-4">
              <RadioGroup
                row
                value={userType}
                name="user-type-group-disabled"
              >
                <FormControlLabel
                  value={userType}
                  disabled
                  control={
                    <Radio
                      sx={{
                        '&.Mui-checked': {
                          color: '#3b82f6',
                        },
                        '&.Mui-disabled': {
                          color: '#3b82f6',
                        },
                      }}
                    />
                  }
                  label={userType === 'client' ? 'Client' : 'Vendor'}
                  sx={{
                    '& .MuiFormControlLabel-label.Mui-disabled': {
                      color: '#3b82f6',
                    },
                  }}
                />
              </RadioGroup>
            </div>
          )}
          <div className="flex items-center justify-center mb-6">
            <div>
              <ul className="flex bg-white rounded-full p-1 border border-blue-500">
                {[
                  { label: "One-Time", value: "onetime" },
                  { label: "Monthly", value: "monthly" },
                  { label: "Yearly", value: "yearly" }
                ].map((plan) => (
                  <li key={plan.value}>
                    <button
                      onClick={() => setPlanType(plan.value)}
                      className={`relative px-5 py-2 text-sm font-medium transition-all duration-300 rounded-full 
              ${planType === plan.value
                          ? "bg-blue-500 text-white"
                          : "text-gray-600 hover:text-gray-900"
                        }`}
                    >
                      {plan.label}
                    </button>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          {!custom && (
            <>
              <label className="block text-gray-700 font-medium mb-2">Search {userType === "client" ? "Client" : "Vendor"}</label>
              <Autocomplete
                value={selectedUser}
                onChange={(event, newValue) => {
                  setSelectedUser(newValue);
                }}
                inputValue={search}
                onInputChange={(event, newValue) => {
                  setSearch(newValue || "");
                }}
                loading={loading}
                loadingText="Searching..."
                disablePortal
                id="user-search"
                options={users}
                getOptionLabel={(option) => getUserDisplayName(option)}
                isOptionEqualToValue={(option, value) => {
                  if (!option || !value) return false;
                  if (typeof option === "object" && typeof value === "object") {
                    return option.id === value.id;
                  }
                  return option === value;
                }}
                fullWidth
                noOptionsText={
                  debouncedSearch.length > 0
                    ? `No ${userType === "client" ? "clients" : "vendors"} found`
                    : `Type to search ${userType === "client" ? "clients" : "vendors"}`
                }
                renderInput={(params) => (
                  <TextField
                    {...params}
                    placeholder={`Type to search ${userType === "client" ? "clients" : "vendors"}`}
                    InputProps={{
                      ...params.InputProps,
                      endAdornment: (
                        <>
                          {loading ? <div className="mr-2">Loading...</div> : null}
                          {params.InputProps.endAdornment}
                        </>
                      ),
                    }}
                  />
                )}
                renderOption={(props, option) => (
                  <li {...props} key={option.id || option}>
                    {getUserDisplayName(option)}
                  </li>
                )}

              /> </>)}
        </div>

        {fields.map((field, index) => (
          shouldShowField(field) && (
            <div key={index} className="flex items-center justify-between mb-4 border p-3 rounded-lg bg-gray-50">
              <span className="text-gray-700 font-medium w-1/3">{field}</span>
              {renderFieldControl(field)}
            </div>
          )
        ))}

        {/* Payment section */}
        <div className="border p-4 rounded-lg bg-gray-50 mb-4">
          <div className="flex items-center justify-between mb-3">
            <h3 className="text-lg font-semibold text-gray-800">Payment Details</h3>
            <FormControlLabel
              control={
                <Checkbox
                  checked={sendEmail}
                  onChange={(e) => setSendEmail(e.target.checked)}
                  sx={{
                    color: '#3b82f6',
                    '&.Mui-checked': { color: '#3b82f6' },
                  }}
                />
              }
              label="Send Email"
            />
          </div>
          {/* Currency */}
          <div className="flex items-center justify-between mb-3">
            <span className="text-gray-700 font-medium">Currency</span>
            <Select
              value={currency}
              onChange={(e) => setCurrency(e.target.value)}
              size="small"
              sx={{
                width: '150px',
                '& .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#3b82f6',
                },
                '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#3b82f6',
                },
                '&:hover .MuiOutlinedInput-notchedOutline': {
                  borderColor: '#3b82f6',
                },
              }}
            >
              <MenuItem value="INR">INR</MenuItem>
              <MenuItem value="USD">USD</MenuItem>
            </Select>
          </div>

          {/* Sub Total */}
          <div className="flex items-center justify-between mb-3">
            <span className="text-gray-700 font-medium">Sub Total</span>
            <TextField
              type="text"
              value={subTotal}
              onChange={(e) => setSubTotal(e.target.value.replace(/[^0-9]/g, ''))}
              size="small"
              sx={{
                width: '150px',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#3b82f6',
                  },
                  '&:hover fieldset': {
                    borderColor: '#3b82f6',
                  },
                  '&.Mui-focused fieldset': {
                    borderColor: '#3b82f6',
                  },
                },
              }}
            />
          </div>

          <div className="flex items-center justify-between mb-3">
            <span className="text-gray-700 font-medium">{currency === 'INR' ? 'GST Amount' : 'Service Tax Amount'}</span>
            <TextField
              type="number"
              value={taxAmount.toFixed(2)}
              size="small"
              sx={{
                width: '150px',
                backgroundColor: '#f0f4ff',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#3b82f6',
                  },
                },
              }}
              InputProps={{
                startAdornment: currency === "INR" ? "₹" : "$",
              }}
            />
          </div>

          {/* Final Amount */}
          <div className="flex items-center justify-between">
            <span className="text-gray-700 font-medium">Final Amount</span>
            <TextField
              type="number"
              value={Math.round(finalAmount.toFixed(2))}
              size="small"
              sx={{
                width: '150px',
                backgroundColor: '#f0f4ff',
                '& .MuiOutlinedInput-root': {
                  '& fieldset': {
                    borderColor: '#3b82f6',
                  },
                },
              }}
              InputProps={{
                startAdornment: currency === "INR" ? "₹" : "$",
              }}
            />
          </div>
        </div>

        <Button
          className="w-full bg-blue-600 text-white py-2 rounded-lg font-medium hover:bg-blue-700 mt-4"
          // disabled={!selectedUser}
          variant="contained"
          color="primary"
          onClick={handleSubmit}
        >
          Create Subscription
        </Button>
      </Card>
    </div>
  );
}